import React, { useEffect } from "react";
import Icon from "components/AppIcon";

const TOAST_CONFIG = {
  success: { icon: "CheckCircle", color: "text-emerald-600", bg: "bg-emerald-50", border: "border-l-4 border-[#00BCD4]" },
  error: { icon: "XCircle", color: "text-red-600", bg: "bg-red-50", border: "border border-red-200" },
  warning: { icon: "AlertTriangle", color: "text-amber-600", bg: "bg-amber-50", border: "border border-amber-200" },
  info: { icon: "Info", color: "text-teal-600", bg: "bg-teal-50", border: "border border-teal-200" },
};

const ToastNotification = ({ toasts, onRemove }) => {
  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm w-full pointer-events-none">
      {toasts?.map((toast) => {
        const config = TOAST_CONFIG?.[toast?.type] || TOAST_CONFIG?.info;
        return (
          <div
            key={toast?.id}
            className={`toast-enter pointer-events-auto flex items-start gap-3 p-4 rounded-xl shadow-lg ${config?.bg} ${config?.border}`}
          >
            <Icon name={config?.icon} size={18} className={config?.color} />
            <div className="flex-1 min-w-0">
              {toast?.title && (
                <p className={`text-sm font-caption font-semibold ${config?.color}`}>{toast?.title}</p>
              )}
              <p className="text-xs font-caption mt-0.5" style={{ color: "var(--color-foreground)" }}>{toast?.message}</p>
            </div>
            <button onClick={() => onRemove(toast?.id)} className="flex-shrink-0 btn-icon-hover">
              <Icon name="X" size={14} color="var(--color-muted-foreground)" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default ToastNotification;